import React, { Component } from 'react'
import AppStatus from '../../../presentationals/Admin/ApplicationLeads/ApplicationStatus.component';
import { connect } from 'react-redux';
import { APIS } from '../../../../utils/api-factory';
import ConfirmationPopup from '../../../presentationals/Popup/ConfirmationPopup.component'
// import EditUserDetail from '../CustomerPages/EditUserDetails.container'
import EditUserDetail from '../CustomerPages/AllApplicationsEditDetails/Main';
import Popup from '../../../presentationals/Popup/Popup.component'
import { bindActionCreators } from 'redux';
import moment from 'moment';
import {
    getAllDetail, getAllDetailByMail, getAllDetailByMobile, mobileVerifyApi, getAllTeaGardenApi, getformlistapi,
    getCommunicationStatusByUserId, getCommunicationCommentsByUserId,
    SaveUpdateCommentsDetails, SaveUpdateCALLDetailsStatus, GetAllAplicationshwwtdownloadBydate
} from '../AdminActionCreator.component';

var sortJsonArray = require('sort-json-array');
const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;


let isDeleteUser = false
let paginationNumber = 10
class ApplicationStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            forwordPageState: 1,
            confirmationPopup: false,
            confirmationText: '',
            userIdForDelete: '',
            loadarState: false,
            FilteredData: [],
            pageIndexToShow: 0,
            allDetail: '',
            userDetails: '',
            viewState: "applicationStatus",
            userOtherInfo: false,
            isError: false,
            confirmationPopupType: '',
            userIdForUnsubscribe: '',
            dataChange: '',
            newData: '',
            popupStatus: '',
            popupState: false,
            teaGardenId: '',
            employeeId: '',
            teaGardenData: [
                // {
                //     "id": 1,
                //     "teaGardenId": "kCV6VBiWe9FlUQTuiBuBoASA7NsgkRAs",
                //     "addedOn": 1653211520747,
                //     "updatedOn": 1653211520747,
                //     "tea_garden_name": "Tea Garden NE",
                //     "emailId": "teagardenne@infitouch.in",
                //     "pwd": "teagardenne@123"
                // }
            ],
            tableMinPagination: 0,
            tableMaxPagination: paginationNumber,
            formStatus: '',
            statsData: '',
            startDate: new Date(),
            endDate: new Date(),
            startDateToshow: moment(new Date()).format('YYYY-MM-DD'),
            endDateToshow: moment(new Date()).format('YYYY-MM-DD'),
            formStatusList: [],
            bucketType: '',
            InternalScoringPopup: { show: false, data: {} },
            commPopupData: { show: false, dataValue: {} },
            PopupViewTab: "communication",
            commentData: { addedcomment: '', commentList: [] },
            communicationList: [],
            showPopupTabsValue: { callOption: false, commentOption: false },
            communicationDetailType: '',
            callDetailData: "",
            infitouchDecision: "",
            panNumberSearched: "",
            chatTaboption:{show:false,data:{}},
            userType:"BORROWER",
            flowType:""

        }
    }
    teaChangeHandler(e, type) {
        if (type === 'teaGardenId') {
            this.setState({ teaGardenId: e.target.value }, () => this.getUpdatedApplications())
        }
        if (type === 'employeeId') {
            this.setState({ employeeId: e.target.value }, () => this.getUpdatedApplications())
        }
    }
    getTeaGardens() {
        getAllTeaGardenApi(1, 500, callBack => {
            this.setState({ teaGardenData: callBack })
        })
    }
    getUpdatedApplications() {
        this.setState({ loadarState: true,panNumberSearched: "" })
        fetch(APIS.UPDATED_APPLICATION_STATUS + this.state.forwordPageState + '&teaGardenId=' + this.state.teaGardenId + '&teaGardenEmpId=' + this.state.employeeId + '&formStatus=' + this.state.formStatus + '&startDate=' + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + '&bucketType=' + this.state.bucketType + "&userType=" + this.state.userType + "&userFlow=" + this.state.flowType + "&breDecision=" + this.state.infitouchDecision)
            .then(res => res.json())
            .then(res => {
                this.setState({ newData: res }, () => {
                    fetch(APIS.ALL_APLLICATION_STATS + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + '&bucketType=' + this.state.bucketType + "&userType=" + this.state.userType + "&userFlow=" + this.state.flowType)
                        .then(res => res.json())
                        .then(res => {
                            this.setState({ statsData: res, loadarState: false })
                        })

                })
            })
    }
    componentDidMount() {
        this.getUpdatedApplications()

        this.getTeaGardens()
        getformlistapi(this.state.userType,this.state.flowType,callBack => {
            this.setState({ formStatusList: callBack })
        })
    }

    componentWillMount() {
        // this.getAllDetail()
    }

    getAllDetail() {
        this.setState({ loadarState: true })
        this.props.getAllDetail(this.state.forwordPageState,
            (callBack) => {
                if (callBack == "error") {
                    this.setState({
                        isError: true
                    })
                } else {
                    this.setState({ loadarState: false })
                }
            });
    }

    forwordpage() {
        this.setState({ forwordPageState: this.state.forwordPageState + 1 }, () => this.getAllDetail())
    }

    backpage() {
        if (this.state.forwordPageState > 1) {
            this.setState({ forwordPageState: this.state.forwordPageState - 1 }, () => this.getAllDetail())
        }
    }
    phocketTablePagination(data, type) {
        if (type == 'back') {
            if (this.state.tableMinPagination >= paginationNumber) {
                this.setState({
                    tableMinPagination: this.state.tableMinPagination - paginationNumber,
                    tableMaxPagination: this.state.tableMaxPagination - paginationNumber,
                })
            }
        } else if (type == 'forward') {
            if (this.state.tableMaxPagination < data.length) {
                this.setState({
                    tableMaxPagination: this.state.tableMaxPagination + paginationNumber,
                    tableMinPagination: this.state.tableMinPagination + paginationNumber
                })
            }
        }
    }
    paginationHandler(type) {
        if (type == 'left') {
            if (this.state.forwordPageState > 1) {
                this.setState({
                    forwordPageState: this.state.forwordPageState - 1,
                    tableMinPagination: 0,
                    tableMaxPagination: paginationNumber,
                }, () => this.getUpdatedApplications())
            }
        }
        if (type == 'right') {
            this.setState({
                forwordPageState: this.state.forwordPageState + 1,
                tableMinPagination: 0,
                tableMaxPagination: paginationNumber,
            }, () => this.getUpdatedApplications())
        }
    }

    componentDidUpdate() {
        const { allUserDetail } = this.props;
        if (allUserDetail.length > 0) {
            if (document.getElementById("forword") != null)
                document.getElementById("forword").disabled = false;
        } else {
            if (document.getElementById("forword") != null)
                document.getElementById("forword").disabled = false;
        }
    }
    closePopup() {
        this.setState({ popupState: false })
    }
    removePopup() {
        setTimeout(function () {
            this.setState({ popupState: false });
        }.bind(this), 5000)
    }
    statusHandler(e) {
        this.setState({ formStatus: e.target.value })
       this.setState({ loadarState: true,panNumberSearched: "" })
        fetch(APIS.UPDATED_APPLICATION_STATUS + this.state.forwordPageState + '&teaGardenId=' + this.state.teaGardenId + '&teaGardenEmpId=' + this.state.employeeId + '&formStatus=' + e.target.value + '&startDate=' + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + "&userType=" + this.state.userType  + "&userFlow=" + this.state.flowType + "&breDecision=" + this.state.infitouchDecision)
            .then(res => res.json())
            .then(res => {
                this.setState({ newData: res }, () => {
                    fetch(APIS.ALL_APLLICATION_STATS + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + "&userType=" + this.state.userType + "&userFlow=" + this.state.flowType)
                        .then(res => res.json())
                        .then(res => {
                            this.setState({ statsData: res, loadarState: false })
                        })


                })
            })

    }
    infitouchDecisionHandler(e) {
        this.setState({ infitouchDecision: e.target.value })
       this.setState({ loadarState: true,panNumberSearched: "" })
        fetch(APIS.UPDATED_APPLICATION_STATUS + this.state.forwordPageState + '&teaGardenId=' + this.state.teaGardenId + '&teaGardenEmpId=' + this.state.employeeId + '&formStatus=' + this.state.formStatus + '&startDate=' + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + "&breDecision=" + e.target.value + "&userType=" + this.state.userType  + "&userFlow=" + this.state.flowType)
            .then(res => res.json())
            .then(res => {
                this.setState({ newData: res }, () => {
                    fetch(APIS.ALL_APLLICATION_STATS + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY')+ "&userType=" + this.state.userType + "&userFlow=" + this.state.flowType)
                        .then(res => res.json())
                        .then(res => {
                            this.setState({ statsData: res, loadarState: false })
                        })


                })
            })

    }
    filterData() {
        this.setState({ loadarState: true,panNumberSearched: "" })
        fetch(APIS.UPDATED_APPLICATION_STATUS + this.state.forwordPageState + '&teaGardenId=' + this.state.teaGardenId + '&teaGardenEmpId=' + this.state.employeeId + '&formStatus=' + this.state.formStatus + '&startDate=' + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + '&bucketType=' + this.state.bucketType + "&userType=" + this.state.userType  + "&userFlow=" + this.state.flowType  + "&breDecision=" + this.state.infitouchDecision)
            .then(res => res.json())
            .then(res => {
                this.setState({ newData: res }, () => {
                    fetch(APIS.ALL_APLLICATION_STATS + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + "&userType=" + this.state.userType + "&userFlow=" + this.state.flowType)
                        .then(res => res.json())
                        .then(res => {
                            this.setState({ statsData: res, loadarState: false })
                        })

                })
            })

    }
    dateHandle(e, type) {
        if (type === 'start') {
            this.setState({ startDate: e.target.value, startDateToshow: e.target.value })
        }
        if (type === 'end') {
            this.setState({ endDate: e.target.value, endDateToshow: e.target.value })


        }
    }
    handleStepChange(step) {
        // setActiveStep(step);
    };
    CustomStepIcon({ active, completed, index, data }) {

        return (
            <div
                style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    backgroundColor: '#267DFF',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '16px',
                    marginTop: '-16px',
                    // zIndex:'1',
                }}
            >
                {data.count}
                {/* {console.log(active, completed,)} */}
            </div>
        );
    };
    changeBucket(type) {
        this.setState({ bucketType: type })
        this.setState({ loadarState: true,panNumberSearched: "" })
        fetch(APIS.UPDATED_APPLICATION_STATUS + this.state.forwordPageState + '&teaGardenId=' + this.state.teaGardenId + '&teaGardenEmpId=' + this.state.employeeId + '&formStatus=' + this.state.formStatus + '&startDate=' + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + '&bucketType=' + type + "&userType=" + this.state.userType  + "&userFlow=" + this.state.flowType + "&breDecision=" + this.state.infitouchDecision)
            .then(res => res.json())
            .then(res => {
                this.setState({ newData: res }, () => {
                    fetch(APIS.ALL_APLLICATION_STATS + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + '&bucketType=' + type + "&userType=" + this.state.userType + "&userFlow=" + this.state.flowType)
                        .then(res => res.json())
                        .then(res => {
                            this.setState({ statsData: res, loadarState: false })
                        })

                })
            })
    }

    handleInternalScoringPopup(type, d) {
        this.setState({ InternalScoringPopup: { show: type, data: d } })
    }

    handleCommLogsPopup(value, data) {
        if (value == true) {

            this.GetUploadedCommunicationStatusList(data)
        }
        else if (value == false) {
            this.setState({
                commentData: { addedcomment: '', commentList: [] },
                commPopupData: { show: false, dataValue: {} },
                PopupViewTab: 'communication'
            })
            this.getUpdatedApplications()


            getformlistapi(this.state.userType,this.state.flowType,callBack => {
                this.setState({ formStatusList: callBack })
            })
        }
        this.setState({ commPopupData: { show: value, dataValue: data } })
    }


    GetUploadedCommunicationStatusList(data) {
        getCommunicationStatusByUserId(data?.userId, (callback) => {
            console.log(callback)
            if (callback && callback?.status == 200 && callback?.message == "success") {
                this.setState({
                    communicationList: callback?.data,
                })
            } else {
                this.setState({
                    communicationList: [],
                })
            }
        })
    }

    PopupbuttonHandle(value) {
        this.setState({ PopupViewTab: value, showPopupTabsValue: { callOption: false, commentOption: false } })
        if (value === "comment") {
            this.GetUploadedCommentsList()
        } else if (value === "communication") {
            this.GetUploadedCommunicationStatusList(this.state.commPopupData.dataValue)
        }
    }

    GetUploadedCommentsList() {
        getCommunicationCommentsByUserId(this.state.commPopupData.dataValue?.userId, (callback) => {
            console.log(callback)
            if (callback && callback?.status == 200 && callback?.message == "success") {
                this.setState({
                    commentData: { addedcomment: '', commentList: callback?.data },
                })
            } else {
                this.setState({
                    commentData: { addedcomment: '', commentList: [] },
                })
            }
        })
    }

    HandlePopupAddBtn(type, functionality) {
        if (functionality === "open") {
            if (type === "call") {
                this.setState({ showPopupTabsValue: { callOption: true, commentOption: false } })
            } else if (type === "comment") {
                this.setState({ showPopupTabsValue: { callOption: false, commentOption: true } })
            }
        } else if (functionality === "close") {
            if (type === "call") {
                this.setState({ showPopupTabsValue: { callOption: false, commentOption: false } })
            } else if (type === "comment") {
                this.setState({ showPopupTabsValue: { callOption: false, commentOption: false } })
            }
        }

    }

    AddCommentHandler(e) {
        this.setState((prevState) => ({
            commentData: {
                addedcomment: e.target.value,
                commentList: prevState.commentData.commentList
            }
        }));
    }

    SaveCommentInPopup() {
        const { admin } = this.props;
        const data = {
            userId: this.state.commPopupData.dataValue?.userId,
            // comment: this.state.commentData?.addedcomment,
            comment: this.state.commentData?.addedcomment,
            commentBy: admin.emailId
        }
        SaveUpdateCommentsDetails(data, callback => {
            if (callback == "success") {
                this.setState({
                    commentData: { addedcomment: '', commentList: [] },
                    popupState: true,
                    popupStatus: "Comment Saved"
                }, () => this.GetUploadedCommentsList())
            } else {
                this.setState({
                    popupState: true,
                    popupStatus: "Error Saving Comment"
                }, () => this.GetUploadedCommentsList())
            }
            this.removePopup()

        })

    }
    handlecommunicationDetailTypechange(e) {
        this.setState({ communicationDetailType: e.target.value })
    }
    AddCallDetailHandler(e) {
        this.setState({ callDetailData: e.target.value })
    }

    SaveCallDetailInPopup() {
        const { admin } = this.props;
        const data = {
            userId: this.state.commPopupData.dataValue?.userId,
            formStatus: this.state.commPopupData.dataValue?.formStatus,
            body: this.state.callDetailData,
            communicationType: this.state.communicationDetailType,
            empId: admin.emailId
        }


        SaveUpdateCALLDetailsStatus(data, callback => {
            if (callback == "Log saved successfully") {
                this.setState({
                    callDetailData: "",
                    communicationList: [],
                    popupState: true,
                    popupStatus: "Call Details Saved"
                }, () => this.GetUploadedCommunicationStatusList(this.state.commPopupData.dataValue))
            } else {
                this.setState({
                    popupState: true,
                    popupStatus: "Error Saving Call Details"
                }, () => this.GetUploadedCommunicationStatusList(this.state.commPopupData.dataValue))
            }
            this.removePopup()

        })
    }

    handledownloadExcel() {
        this.setState({ loadarState: true })
        GetAllAplicationshwwtdownloadBydate(moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'),this.state.formStatus,this.state.flowType,this.state.infitouchDecision,this.state.userType, callBack => {
            this.setState({ loadarState: false })
        })
    }

    handleOpenchatTab(type,data){
        this.setState({chatTaboption:{show:type,data:data}})
    }

    handleUserType(value){
        this.setState({userType:value,loadarState:true})
         fetch(APIS.UPDATED_APPLICATION_STATUS + this.state.forwordPageState + '&teaGardenId=' + this.state.teaGardenId + '&teaGardenEmpId=' + this.state.employeeId + '&formStatus=' + this.state.formStatus + '&startDate=' + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + '&bucketType=' + this.state.bucketType + "&userType=" + value  + "&userFlow=" + this.state.flowType + "&breDecision=" + this.state.infitouchDecision)
            .then(res => res.json())
            .then(res => {
                this.setState({ newData: res }, () => {
                    fetch(APIS.ALL_APLLICATION_STATS + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + '&bucketType=' + this.state.bucketType + "&userType=" + this.state.userType + "&userFlow=" + this.state.flowType)
                        .then(res => res.json())
                        .then(res => {
                            this.setState({ statsData: res, loadarState: false })
                        })

                })
            })
             getformlistapi(value,this.state.flowType,callBack => {
            this.setState({ formStatusList: callBack })
        })
    }

    handleFlowType(e){
        this.setState({flowType:e.target.value})
        this.setState({ loadarState: true })
        fetch(APIS.UPDATED_APPLICATION_STATUS + this.state.forwordPageState + '&teaGardenId=' + this.state.teaGardenId + '&teaGardenEmpId=' + this.state.employeeId + '&formStatus=' + this.state.formStatus + '&startDate=' + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + '&bucketType=' + this.state.bucketType + "&panNo=" + this.state.panNumberSearched + "&userType=" + this.state.userType  + "&userFlow=" + e.target.value + "&breDecision=" + this.state.infitouchDecision)
            .then(res => res.json())
            .then(res => {
                this.setState({ newData: res }, () => {
                    fetch(APIS.ALL_APLLICATION_STATS + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + '&bucketType=' + this.state.bucketType + "&userType=" + this.state.userType + "&userFlow=" + this.state.flowType)
                        .then(res => res.json())
                        .then(res => {
                            this.setState({ statsData: res, loadarState: false })
                        })

                })
            })
              getformlistapi(this.state.userType,e.target.value,callBack => {
                this.setState({ formStatusList: callBack })
            })
    }

    render() {
        const steps = this.state.statsData !== '' && (this.state.statsData?.statusList)?.length > 0 ? (this.state.statsData?.statusList)?.map((item, index) => ({
            // label: `${item.form_status} (${item.count})`,
            label: `${item.status}`,
            count: `${item.count}`,

            index: index + 1,
        })) : "";
        const { allUserDetail, admin, pageViewHandler } = this.props;
        if (admin != null) {
            if (admin.role != null && admin.role == 'superuser') {
                isDeleteUser = true
            }
        }
        return (
            <div className="full-height">
                {this.state.viewState == 'applicationStatus' ?
                    <div>
                        {this.state.isError ?
                            <h3 className="text-center blue-text">Something Went Wrong</h3>
                            : <AppStatus
                                bucketType={this.state.bucketType}
                                changeBucket={this.changeBucket.bind(this)}
                                statsData={this.state.statsData}
                                formStatusList={this.state.formStatusList}
                                CustomStepIcon={this.CustomStepIcon.bind(this)}
                                handleStepChange={this.handleStepChange.bind(this)}
                                steps={steps}
                                startDateToshow={this.state.startDateToshow}
                                endDateToshow={this.state.endDateToshow}
                                dateHandle={this.dateHandle.bind(this)}
                                filterData={this.filterData.bind(this)}
                                statusHandler={this.statusHandler.bind(this)}
                                formStatus={this.state.formStatus}
                                paginationHandler={this.paginationHandler.bind(this)}
                                phocketTablePagination={this.phocketTablePagination.bind(this)}
                                tableMaxPagination={this.state.tableMaxPagination}
                                tableMinPagination={this.state.tableMinPagination}
                                admin={admin}
                                teaChangeHandler={this.teaChangeHandler.bind(this)}
                                teaGardenId={this.state.teaGardenId}
                                teaGardenData={this.state.teaGardenData}
                                varifyMobile={this.varifyMobile.bind(this)}
                                forwordpage={this.forwordpage.bind(this)}
                                backpage={this.backpage.bind(this)}
                                allUserDetail={this.state.newData}
                                // allUserDetail={allUserDetail != null ? sortJsonArray(allUserDetail, 'loginDate', 'des') : ""}
                                dataFilter={this.dataFilter.bind(this)}
                                deleteUserHandler={this.deleteUserHandler.bind(this)}
                                isDeleteUser={isDeleteUser}
                                getFilterValue={this.getFilterValue.bind(this)}
                                FilteredData={this.state.FilteredData}
                                getPageValue={this.getPageValue.bind(this)}
                                pageIndexToShow={this.state.pageIndexToShow}
                                editUserHandler={this.editUserHandler.bind(this)}
                                loadarState={this.state.loadarState}
                                unsubscribeHandler={this.unsubscribeHandler.bind(this)}
                                InternalScoringPopup={this.state.InternalScoringPopup}
                                handleInternalScoringPopup={this.handleInternalScoringPopup.bind(this)}
                                commPopupData={this.state.commPopupData}
                                handleCommLogsPopup={this.handleCommLogsPopup.bind(this)}
                                PopupbuttonHandle={this.PopupbuttonHandle.bind(this)}
                                showPopupTabsValue={this.state.showPopupTabsValue}
                                HandlePopupAddBtn={this.HandlePopupAddBtn.bind(this)}
                                AddCommentHandler={this.AddCommentHandler.bind(this)}
                                SaveCommentInPopup={this.SaveCommentInPopup.bind(this)}
                                communicationDetailType={this.state.communicationDetailType}
                                handlecommunicationDetailTypechange={this.handlecommunicationDetailTypechange.bind(this)}
                                AddCallDetailHandler={this.AddCallDetailHandler.bind(this)}
                                SaveCallDetailInPopup={this.SaveCallDetailInPopup.bind(this)}
                                communicationList={this.state.communicationList}
                                PopupViewTab={this.state.PopupViewTab}
                                commentData={this.state.commentData}
                                infitouchDecision={this.state.infitouchDecision}
                                infitouchDecisionHandler={this.infitouchDecisionHandler.bind(this)}
                                handledownloadExcel={this.handledownloadExcel.bind(this)}
                                pageViewHandler={pageViewHandler}
                                panNumberSearched={this.state.panNumberSearched}
                                chatTaboption={this.state.chatTaboption}
                                handleOpenchatTab={this.handleOpenchatTab.bind(this)}
                                userType={this.state.userType}
                                handleUserType={this.handleUserType.bind(this)}
                                handleFlowType={this.handleFlowType.bind(this)}
                                flowType={this.state.flowType}
                            />}
                    </div>
                    : this.state.viewState == 'editDetails' ?
                        <div>
                            <h3 className="text-center blue-text">
                                <span className="fa fa-chevron-left pull-left pointer" onClick={(e) => this.ediDetailBackHandler()} />
                                <strong className="teal-text text-uppercase">{this.state.userDetails.firstName}  ({this.state.userDetails.applicationId})</strong>
                            </h3>
                            <EditUserDetail
                                getData={this.getData.bind(this)}
                                ediDetailBackHandler={this.ediDetailBackHandler.bind(this)}
                                admin={admin}
                                allDetail={this.state.allDetail}
                                userDetails={this.state.userDetails}
                                userOtherInfo={this.state.userOtherInfo}
                            />
                        </div>
                        : null}
                {this.state.popupState ?
                    <Popup popupStatus={this.state.popupStatus} />
                    : ""}
                {this.state.confirmationPopup == true ?
                    <ConfirmationPopup
                        cancelLoanConfirm={this.cancelLoanConfirm.bind(this)}
                        confirmationText={this.state.confirmationText} />
                    : ""}
            </div>
        )
    }
    getData(val) {
        this.setState({ dataChange: val })
    }
    unsubscribeHandler(userId) {
        this.setState({
            userIdForUnsubscribe: userId,
            confirmationPopupType: 'unsubscribe',
            confirmationPopup: true,
            confirmationText: 'Are you sure to Unsubscribe this user'
        })
    }

    editUserHandler(userDetails) {
        // this.setState({ loadarState: true })
        // fetch(APIS.APPLICATION_STATUS_DETAIL_USER + userDetails.userId)


        //     .then(res => res.json())
        //     .then(res => {
        //         this.setState({
        //             loadarState: false,
        //             allDetail: res,
        //             userDetails: userDetails,
        //             viewState: 'editDetails'
        //         })
        //     })
        this.setState({ viewState: 'editDetails', userDetails: userDetails })
    }

    ediDetailBackHandler() {
        this.setState({
            viewState: 'applicationStatus'
        })
    }

    getFilterValue(filtered) {
        this.setState({ FilteredData: filtered })
    }

    getPageValue(pageIndex) {
        this.setState({ pageIndexToShow: pageIndex })
    }

    deleteUserHandler(userId) {
        this.setState({
            userIdForDelete: userId,
            confirmationPopupType: 'delete',
            confirmationPopup: true,
            confirmationText: 'Are you sure to Delete this user'
        })
    }
    varifyMobile(userId) {
        this.setState({
            userIdForDelete: userId,
            confirmationPopupType: 'Verify',
            confirmationPopup: true,
            confirmationText: 'Are you sure to Verify Mobile Number'
        })
    }

    cancelLoanConfirm(conType) {
        if (conType == 'yes') {
            if (this.state.confirmationPopupType == 'delete') {
                fetch(APIS.DELETE_COMPLETE_USER + this.state.userIdForDelete)
                    .then(res => res.text())
                    .then(text => {
                        if (text == 'success') {
                            this.setState({ confirmationPopup: false })
                            this.getAllDetail()
                        }
                    })
            } else if (this.state.confirmationPopupType == 'unsubscribe') {
                fetch(APIS.UNSUBSCRIBE_MAIL + this.state.userIdForUnsubscribe)
                    .then(res => res.text())
                    .then(text => {
                        if (text == 'success') {
                            this.setState({ confirmationPopup: false })
                        }
                    })
            }
            else if (this.state.confirmationPopupType == 'Verify') {
                this.setState({ loadarState: true })
                mobileVerifyApi(this.state.userIdForDelete, callBack => {
                    if (callBack === 'success') {
                        this.setState({ loadarState: false, confirmationPopup: false, popupState: true, popupStatus: 'Successfully Verified!' }, () => this.removePopup())
                    } else {
                        this.setState({ loadarState: false, confirmationPopup: false, popupState: true, popupStatus: 'Not Verified!' }, () => this.removePopup())

                    }
                })

            }
        } else if (conType == 'no') {
            this.setState({ confirmationPopup: false })
        }
    }

    dataFilter(e, filterType) {
        if (filterType == 'email') {
            let email = e.target.value
            this.setState({ loadarState: true })
            if (email.length > 4) {
                this.props.getAllDetailByMail(email, this.state.forwordPageState,
                    (callBack) => {
                        this.setState({ loadarState: false, newData: callBack })
                    });
            }
        } else if (filterType == 'mobileNo') {
            let mobile = e.target.value
            this.setState({ loadarState: true })
            if (mobile.length == 10) {
                this.props.getAllDetailByMobile(mobile, this.state.forwordPageState,
                    (callBack) => {
                        this.setState({ loadarState: false, newData: callBack })
                    });
            }
        }
        else if (filterType == "panNo") {
            let pan = e.target.value
            console.log("e.targ",e.target.value)
            // if (panRegex.test(pan)) {
                this.handlePanfilter(pan)
            // }
        }
        if (e.target.value == "") {
            this.getUpdatedApplications()
        }
    }
    handlePanfilter(type) {
        this.setState({ panNumberSearched: type })
        this.setState({ loadarState: true })
        fetch(APIS.UPDATED_APPLICATION_STATUS + this.state.forwordPageState + '&teaGardenId=' + this.state.teaGardenId + '&teaGardenEmpId=' + this.state.employeeId + '&formStatus=' + this.state.formStatus + '&startDate=' + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + '&bucketType=' + this.state.bucketType + "&panNo=" + type + "&userType=" + this.state.userType  + "&userFlow=" + this.state.flowType + "&breDecision=" + this.state.infitouchDecision)
            .then(res => res.json())
            .then(res => {
                this.setState({ newData: res }, () => {
                    fetch(APIS.ALL_APLLICATION_STATS + moment(this.state.startDate).format('DD-MM-YYYY') + '&endDate=' + moment(this.state.endDate).format('DD-MM-YYYY') + '&bucketType=' + this.state.bucketType + "&userType=" + this.state.userType + "&userFlow=" + this.state.flowType)
                        .then(res => res.json())
                        .then(res => {
                            this.setState({ statsData: res, loadarState: false })
                        })

                })
            })
    }
}


const mapStateToProps = ({ allUserDetail }) => {
    return {
        allUserDetail: allUserDetail,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        getAllDetail,
        getAllDetailByMail,
        getAllDetailByMobile
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationStatus);

